import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  reportClosingFilterCountrySelector,
  reportClosingFilterFranchiseTypeSelector,
  changeClosingFilterFranchiseTypes,
} from '../../../state';
import FranchiseTypeFilter from '../../filters/FranchiseTypeFilter';
import { FranchiseType } from '../../../types';

const FranchiseTypeFilterRedux = ({ fullWidth }: { fullWidth?: boolean }) => {
  const dispatch = useDispatch();
  const value = useSelector(reportClosingFilterFranchiseTypeSelector) as FranchiseType[];
  const country = useSelector(reportClosingFilterCountrySelector);
  const disabled = country.length === 0;

  const handleChange = useCallback(
    (value: FranchiseType[]) => {
      dispatch(changeClosingFilterFranchiseTypes(value));
    },
    [dispatch]
  );

  return (
    <FranchiseTypeFilter
      fullWidth={fullWidth}
      value={value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default FranchiseTypeFilterRedux;
